import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';

const styles = theme => ({});

class InfiniteScrollEndMessage extends React.Component {
    render() {
        const { searchReturnedCount, searchTotalCount, nextMarker } = this.props;

        const message = nextMarker || searchTotalCount === 0
            ? (searchReturnedCount === 0
                ? "No results found"
                : searchReturnedCount === 1
                    ? "Showing all search results"
                    : `Showing all ${searchReturnedCount} search results`)
            : `Showing ${searchReturnedCount} of ${searchTotalCount} search results`;

        return (
            <div style={{ padding: '7px 24px' }}>
                <Typography variant="subtitle2" color="secondary" style={{ fontWeight: 'normal' }}>
                    {message}
                </Typography>
            </div>
        );
    }
}

InfiniteScrollEndMessage.propTypes = {
    classes: PropTypes.object.isRequired,
    searchReturnedCount: PropTypes.number.isRequired,
    searchTotalCount: PropTypes.number.isRequired,
    nextMarker: PropTypes.string
};

export default withStyles(styles, { withTheme: true })(InfiniteScrollEndMessage);
